import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "sonner";
import ProtectedRoute from "./components/ProtectedRoute";

import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Catalog from "./pages/Catalog";
import FilmDetail from "./pages/FilmDetail";
import DealRoom from "./pages/DealRoom";
import Vault from "./pages/Vault";
import CreatorStudio from "./pages/CreatorStudio";
import MyFilms from "./pages/MyFilms";
import MyDeals from "./pages/MyDeals";
import AdminDashboard from "./pages/AdminDashboard";

// New feature pages
import Kyc from "./pages/Kyc";
import Watchlist from "./pages/Watchlist";
import Verify from "./pages/Verify";
import CreatorAnalytics from "./pages/CreatorAnalytics";
import EmailInbox from "./pages/EmailInbox";
import OwnershipCredential from "./pages/OwnershipCredential";
import AuctionPage from "./pages/AuctionPage";
import Auctions from "./pages/Auctions";
import HomeRouter from "./components/HomeRouter";

// 25-feature strategic moat hubs
import LegalHub from "./pages/LegalHub";
import IntelHub from "./pages/IntelHub";
import CreatorEconomyHub from "./pages/CreatorEconomyHub";
import AIStudioHub from "./pages/AIStudioHub";
import DistributionHub from "./pages/DistributionHub";

// Static / marketing pages
import SellYourRights from "./pages/SellYourRights";
import HowItWorks from "./pages/HowItWorks";
import LegalFramework from "./pages/LegalFramework";
import Investors from "./pages/Investors";
import Crowdfunding from "./pages/Crowdfunding";
import AboutUs from "./pages/AboutUs";
import Contact from "./pages/Contact";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors theme="dark" />
                <Routes>
                    <Route path="/" element={<HomeRouter />} />
                    <Route path="/home" element={<Landing />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/catalog" element={<Catalog />} />
                    <Route path="/film/:id" element={<FilmDetail />} />

                    {/* Marketing */}
                    <Route path="/sell" element={<SellYourRights />} />
                    <Route path="/how-it-works" element={<HowItWorks />} />
                    <Route path="/legal-framework" element={<LegalFramework />} />
                    <Route path="/investors" element={<Investors />} />
                    <Route path="/crowdfunding" element={<Crowdfunding />} />
                    <Route path="/about" element={<AboutUs />} />
                    <Route path="/contact" element={<Contact />} />

                    <Route
                        path="/deal/:id"
                        element={
                            <ProtectedRoute>
                                <DealRoom />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/vault/:id"
                        element={
                            <ProtectedRoute roles={["buyer", "admin"]}>
                                <Vault />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/creator"
                        element={
                            <ProtectedRoute roles={["creator"]}>
                                <CreatorStudio />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/my-films"
                        element={
                            <ProtectedRoute roles={["creator"]}>
                                <MyFilms />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/my-deals"
                        element={
                            <ProtectedRoute roles={["buyer"]}>
                                <MyDeals />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <ProtectedRoute roles={["admin"]}>
                                <AdminDashboard />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <Catalog />
                            </ProtectedRoute>
                        }
                    />

                    {/* New features */}
                    <Route path="/verify/:hash" element={<Verify />} />
                    <Route
                        path="/kyc"
                        element={
                            <ProtectedRoute>
                                <Kyc />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/inbox"
                        element={
                            <ProtectedRoute>
                                <EmailInbox />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/watchlist"
                        element={
                            <ProtectedRoute roles={["buyer", "admin"]}>
                                <Watchlist />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/analytics"
                        element={
                            <ProtectedRoute roles={["creator", "admin"]}>
                                <CreatorAnalytics />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/credential/:id"
                        element={
                            <ProtectedRoute>
                                <OwnershipCredential />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/auction/:filmId" element={<AuctionPage />} />
                    <Route path="/auctions" element={<Auctions />} />

                    {/* Strategic moat hubs (25 advanced features) */}
                    <Route path="/legal" element={<LegalHub />} />
                    <Route path="/intel" element={<IntelHub />} />
                    <Route
                        path="/economy"
                        element={
                            <ProtectedRoute>
                                <CreatorEconomyHub />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/ai-studio"
                        element={
                            <ProtectedRoute>
                                <AIStudioHub />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/distribution" element={<DistributionHub />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
